<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { storeToRefs } from 'pinia'
import useProductStore from '~/stores/product'
import { useMessagesStore } from '~/stores/messages'
import { useAuthStore } from '~/stores/auth'
import { useWebshopUrl } from '~/composables/useWebshopUrl.js'
import AuCallout from '~/components/ui/AuCallout.vue'

const { t } = useI18n()
const { isTeacher } = storeToRefs(useAuthStore())
const { hasMessage, messages } = storeToRefs(useMessagesStore())
const { noLicensedProducts } = storeToRefs(useProductStore())
const { webshopUrl } = useWebshopUrl()
</script>

<template>
  <section
    v-if="hasMessage || isTeacher && noLicensedProducts"
    class="max-w-screen-au mx-auto px-4 sm:px-8"
  >
    <AuCallout
      v-if="hasMessage"
      :title="messages?.messageTitle"
      variant="warning"
    >
      <div v-html="messages?.message" />
    </AuCallout>
    <AuCallout
      v-if="isTeacher && noLicensedProducts"
      class="my-6"
      :title="t('trial.title')"
      variant="info"
    >
      <div class="prose max-w-none" v-html="t('trial.message', { href: webshopUrl })" />
    </AuCallout>
  </section>
</template>
